export const draftSenderPersonaPlaceholder = "Occ";
export default {draftSenderPersonaPlaceholder};